import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NzImageService } from 'ng-zorro-antd/image';

import { PrintoutPlaceholder } from '@cl/shared/models/printouts/printout-placeholder.model';
import { lastValueFrom, Observable } from 'rxjs';
import { BaseDownloadServiceWithFilter } from './base.service';
import { PrintoutTemplate } from '@cl/shared/models/printouts/printout-template.model';
import { PrintoutTemplateFilter } from '@cl/shared/models/printouts/printout-template-filter.model';
import { CommandResult, PrintoutType } from '@cl/shared/models';
import { FileMetadata } from '@cl/shared/models/file.model';

@Injectable({ providedIn: 'root' })
export class PrintoutTemplateService extends BaseDownloadServiceWithFilter<PrintoutTemplate, PrintoutTemplateFilter> {
    constructor(
        httpClient: HttpClient,
        protected nzImageService: NzImageService,
    ) {
        super(httpClient, '/api/v1/printout-templates/', nzImageService);
    }

    // Izkārtojuma priekšskats no vēl nesaglabātās veidnes; PDF atver tas pats autorizēto
    // failu ceļš, ko lieto pārējie CLARO priekšskati.
    preview(template: PrintoutTemplate): Promise<void> {
        return this.handleFileDownloading(lastValueFrom(this.httpClient.post<CommandResult<FileMetadata>>(`${this.baseApiUrl}preview`, template)));
    }

    getPlaceholders(printoutType: PrintoutType): Observable<PrintoutPlaceholder[]> {
        return this.httpClient.get<PrintoutPlaceholder[]>(`${this.baseApiUrl}placeholders/${printoutType}`);
    }

    getTemplates(printoutType: PrintoutType): Promise<PrintoutTemplate[]> {
        return lastValueFrom(this.httpClient.get<PrintoutTemplate[]>(`${this.baseApiUrl}templates/${printoutType}`));
    }

    getTemplatesForOrderType(printoutType: PrintoutType, orderTypeId: number): Observable<PrintoutTemplate[]> {
        return this.httpClient.get<PrintoutTemplate[]>(`${this.baseApiUrl}templates/${printoutType}/${orderTypeId}`);
    }
}
